module.exports = __webpack_public_path__ + "img/boy_010006.15f34123.png";